export default __webpack_public_path__ + "static/media/logical-thinking.f60d9e46.svg";